export const getCultureFitLabel = (
  cultureScore: number | string | null | undefined,
  t: (key: string) => string
): string => {
  if (Number(cultureScore) === 0) {
    return t('Please select a culture profile to see the culture fit');
  }

  return `${cultureScore ?? 0}% ${t('Cultural Fit')}`;
};
